import { ENV } from "config";

export const DOWNLOAD_INVENTORY_SAMPLE_URL = `https://storage.googleapis.com/${
  ENV === "production" ? "deeple-sme" : "deeple-dev-hk-sme"
}/csv-example/upload-product-inventories-example.csv`;
